export const SCREEN_RECORD_PROMO_STORAGE_KEY = 'screenRecordPromo';

export type ScreenRecordPromoState = {
  bannerStep1ClosedAt?: string;
  bannerStep2ClosedAt?: string;
  bannerStep3ClosedAt?: string;
  hasShownModal?: boolean;
  modalClosedAt?: string;
};

export type BannerStep = 'step1' | 'step2' | 'step3' | null;

export const BANNER_SCHEDULE = {
  step1DelayDays: 1,
  step2DelayDays: 3,
  step3DelayDays: 7,
} as const;
